import { classify } from 'sidecar-utilities'

export const descriptionStyles = 'sh-body-xs'

export const mainContentStyles = 'w-full flex items-center flex-wrap gap-2'

// This is needed because pills shrink to 4xs on mobile
export const pillStyles = '!max-w-3xs'

export const rowStyles = ({ hideChevron, selected = false }) =>
  classify({
    // Hide the arrow on the detail page because the row is not a link anymore
    chevronVisibility: hideChevron && '[&_svg]:hidden',
    // Give the row a blue bg when selected
    selectedBg: selected ? 'color-accent-weak-default' : null,
  })

export const rowChildrenStyles = 'flex items-center gap-2'

export const timeStyles = 'sh-body-xs text-right'

export const titleStyles = ({ selected = false, bolded = false }) => {
  return selected || bolded ? 'sh-strong' : 'inherit-link-color'
}

// These styles allow the pill to get its own column on desktop
// The min-w-40 is needed for the side list on the detail page
export const titleAndDescStyles = 'w-full sm:w-3/5 sm:min-w-40'
